export function bufferToBase64(buffer: ArrayBuffer) {
  // return Buffer.from(buffer).toString("base64");
  const { data } = buffer as unknown as { data: number[] };
  let binary = "";
  const bytes = new Uint8Array(data);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i] as number);
  }
  return window.btoa(binary);
}

export function bufferToObjectURL(buffer: ArrayBuffer) {
  const data = new Blob([buffer], { type: "application/octect-binary" });
  return URL.createObjectURL(data);
}
